import ServiceHero from "../../../components/elements/service-hero";
import FeatureStrip from "../../../components/elements/feature-strip";
import { PricingCardFlex, PricingCard } from "../../../components/elements/pricing-card";
import SectionTitle from "../../../components/elements/section-title";
import CTA from "../../../components/elements/CTA";
import "../ep-courses-and-services-pages.css";

const features = [
  ["▤", "Correção técnica e detalhada"],
  ["☼", "Feedback individualizado"],
  ["♧", "Adequação à banca e ao edital"],
  ["▥", "Orientação para evolução contínua"],
  ["☏", "Mais chances de aprovação"],
];

export default function EssayCorrections() {
  return (
      <>
        <ServiceHero
          eyebrow="Correções para concursos"
          title={
            <>
              Sua redação no concurso com mais segurança e <em>alto desempenho.</em>
            </>
          }
          description="Receba correções completas e personalizadas para concursos públicos e seleções, com foco nos critérios avaliados e nas exigências de cada banca."
          image="/images/correcao-feedback-hero.jpg"
          // quote="Mais do que uma nota, é o seu futuro!"
        />

        <main>
          <div className="container service-body">
            <FeatureStrip
              items={features.map(([icon, label]) => ({ icon, label }))}
            />
            <div className="two-col" id="como-funciona">
              <section className="paper-panel">
                <SectionTitle title="O que você recebe?" />
                <ul className="check-list">
                  <li>Correção completa da redação com base nos Critérios da banca (competência I a V):</li>
                  <li>Comentários detalhados sobre estrutura, coesão, coerência, gramática e repertório sociocultural;</li>
                  <li>Indicação de pontos fortes e aspectos a melhorar;</li>
                  <li>Orientações práticas para evoluir em cada produção;</li>
                  <li>Simulados e correções periódicas (opcional).</li>
                  <li>Mais do que corrigir, é sobre te preparar para conquistar sua vaga!</li>
                </ul>
                <p className="hand-note">
                  Mais do que corrigir, é sobre te preparar para conquistar sua vaga!
                </p>
              </section>
              <section className="paper-panel">
                <SectionTitle title="Nossos planos" />
                <div className="vestibulares-pricing-list">
                  <PricingCard
                    title="Plano Básico"
                    tag="4 redações"
                    price="49,90"
                    unit="/ mês"
                    features={[
                      "Correção com feedback completo",
                      "Orientações de melhoria",
                      "Acompanhamento online",
                    ]}
                  />
                  <PricingCard
                    title="Plano Mensal Intermediário"
                    tag="8 redações"
                    price="89,90"
                    unit="/mês"
                    features={[
                      "Tudo do plano básico",
                      "Estratégias de prova",
                      "Simulados e correções extras",
                    ]}
                  />
                  <PricingCard
                    title="Plano Completo"
                    tag="12 redações"
                    price="129,90"
                    unit="/mês"
                    features={[
                      "Tudo do plano intermediário",
                      "Acompanhamento intensivo",
                      "Revisão de pontos",
                    ]}
                    featured
                  />
                </div>
              </section>
            </div>

            <CTA
              title="Sua aprovação começa com "
              titleBr="uma redação bem construída."
              subtitle="Vamos juntos transformar seu esforço em resultado!"
              button="QUERO ME PREPARAR PARA O CONCURSO"
            />

            <section className="why">
              <SectionTitle
                align="center"
                title="Por que escolher o Escrita Prática?"
              />
              <div className="why-grid">
                {[
                  "Acompanhamento personalizado",
                  "Metodologia comprovada",
                  "Foco em resultados reais",
                  "Experiência e comprometimento",
                  "Feedback construtivo e contínuo",
                ].map((x, i) => (
                  <div key={i}>
                    <b>{["♧", "▤", "▥", "☆", "☏"][i]}</b>
                    <span>{x}</span>
                  </div>
                ))}
              </div>
            </section>
          </div>
        </main>
      </>
  );
}
